module.exports = __webpack_public_path__ + "img/1L3.a602c2ae.png";